module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-up-left-1.bdb195d1.png";